export default {"src":"/_next/static/media/seasonal-use.4c03cdec.svg","height":116,"width":116,"blurWidth":0,"blurHeight":0};